const handleSplashscreen = function () {
    if (navigator.splashscreen) {
        navigator.splashscreen.hide();
    }
}

export {
    handleSplashscreen
}